export const VISITOR_AI_WELCOME_MESSAGE = "Hello! I am the Visitor AI Assistant. How can I help you?";
